export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_14.199999ae.jpg";